export default {
  methods: {
    async confirm(title, message, options = {}) {
      return await this.$root.$confirm(title, message, options);
    }
  }
};
